import { nextTick, ref, toRaw } from 'vue'
import { getCombinationList } from '@/apis/combined'
export const formatCombinationProduct = (v: any, rate: number) => ({
  ...v,
  id: v.combinationProductSku,
  code: v.combinationProductSku,
  name: v.combinationProductName,
  img: v.combinationProductMainImg,
  type: 'combination',
  price: v.productSellPrice ?? 0,
  PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0
})

const formatCombinationProductArr = (data: any, rate: number) => {
  return (data || []).map((t: any) => formatCombinationProduct(t, rate))
}

export default (model: any, keyword: any, rate:any, emits: any) => {
  const loading: any = ref(false)
  const list: any = ref([])
  const total = ref()
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })

  const getList = () => {
    loading.value = true
    getCombinationList({
      keywordName: keyword.value?.trim(),
      startUnitPrice: model.value.sellPriceStart,
      endUnitPrice: model.value.sellPriceEnd,
      ...toRaw(pageData.value)
    }).then((res: any) => {
      list.value = formatCombinationProductArr(res.data?.records, rate.value)
      total.value = res.data.total
      nextTick(() => {
        emits('update:list', list.value)
      })
    }).finally(() => { loading.value = false })
  }

  return [
    loading,
    pageData,
    list,
    total,
    getList
  ]
}
